// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nidorino: PokeData = {
  "id": 33,
  "name": "nidorino",
  "height": 9,
  "weight": 195,
  "base_experience": 128,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "double-kick",
    "horn-attack",
    "fury-attack",
    "horn-drill",
    "tackle",
    "poison-sting",
    "leer",
    "peck",
    "toxic",
    "focus-energy",
    "flatter",
    "helping-hand",
    "toxic-spikes",
    "poison-jab",
    "earth-power",
    "captivate"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "leer",
    "peck",
    "flatter",
    "toxic-spikes",
    "poison-jab",
    "earth-power",
    "acid",
    "poison-powder",
    "toxic-overload",
    "acid-rain",
    "mortal-gas"
  ],
  "evolution_chain": {
    "id": 13,
    "item": null,
    "species": [
      {
        "name": "nidoran-m",
        "order": 33,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "nidorino",
        "order": 34,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 32,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "nidoking",
        "order": 35,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 33,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 58.5,
    "speed": 65,
    "ability_power": 72
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
